import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function PageModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <AccessTimeIcon onClick={handleOpen} sx={{float:"left", marginTop:"13px", marginRight:"10px", color:"#ffea00"}} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Horário de Funcionamento:
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          SEG a SEX: 06:00 às 11:00 - 16:00 às 21:00
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
}